import { PanelType } from '@fluentui/react';
import { useBoolean, useConst } from '@fluentui/react-hooks';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { NotificationsTarget, useNotificationsManager } from '../../contexts/notificationContext';
import { Data } from '../../data/Data';
import { DataCategorieIntervenantEXTPersonne } from '../../data/DataCategorieIntervenantEXTPersonne';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { EUIPanel } from '../EUI/EUIPanel';
import { EUITextField } from '../EUI/EUITextField';

const FicheCategorieIntervenantEXTPersonne = (props) => {

    // CONTEXTS
    const { clear, dismiss, extract, load } = useNotificationsManager();

    // PROPS
    const {
        idCategorieIntervenantEXTPersonne = -1,
        isOpen = false,
        /* --- */
        onDismiss = () => null,
        onSave = () => null
    } = props;

    // CONSTANTES
    const defaultCategorieIntervenantEXTPersonne = useConst({});

    // STATES
    const [_isFormValid, { setFalse: _setFormIsNotValid, setTrue: _setFormIsValid }] = useBoolean(false);

    const [_categorieIntervenantEXTPersonne, _setCategorieIntervenantEXTPersonne] = useState({ ...defaultCategorieIntervenantEXTPersonne });

    // REFS
    const _isMounted = useRef(false); // Utilisé pour bloquer certains useEffect au premier render

    // METHODS
    const _chargementDonnees = useCallback(() => {
        const id = load("Chargement de la catégorie en cours...");
        DataCategorieIntervenantEXTPersonne._detailler(idCategorieIntervenantEXTPersonne).then(response => {
            const onSuccess = () => {
                const categorieIntervenantEXTPersonne = response.reponseAPIobjet;
                _setCategorieIntervenantEXTPersonne(categorieIntervenantEXTPersonne);
            };
            const onError = (result) => extract(result, NotificationsTarget.panels);
            Immocom.checkFetchResponse(response, onSuccess, onError);
            dismiss(id);
        });
    }, [idCategorieIntervenantEXTPersonne]);

    const _resetState = useCallback(() => {
        _setCategorieIntervenantEXTPersonne(defaultCategorieIntervenantEXTPersonne);
    }, []);

    const _onDismiss = useCallback(() => {
        onDismiss();
    }, [onDismiss]);

    const _onOpen = useCallback(() => {
        _resetState();
        if (idCategorieIntervenantEXTPersonne !== -1) _chargementDonnees();
    }, [_resetState, idCategorieIntervenantEXTPersonne]);

    const _onSave = useCallback(() => {
        const id = load("Enregistrement de la catégorie en cours...");
        DataCategorieIntervenantEXTPersonne._enregistrer(_categorieIntervenantEXTPersonne).then(response => {
            const onSuccess = () => {
                onSave();
                _resetState();
            }
            const onError = (result) => extract(result, NotificationsTarget.panels);
            Immocom.checkFetchResponse(response, onSuccess, onError);
            dismiss(id);
        });
    }, [_resetState, _categorieIntervenantEXTPersonne, onSave]);

    const _onVerificationFormulaire = useCallback(() => {
        clear();
        _setFormIsNotValid();
        Data._onValidationFormulaire("CategorieIntervenantEXTPersonne", _categorieIntervenantEXTPersonne, idCategorieIntervenantEXTPersonne !== -1 ? "Modification" : "Création").then(response => {
            const onSuccess = _setFormIsValid;
            const onError = (result) => extract(result, NotificationsTarget.panels);
            Immocom.checkFetchResponse(response, onSuccess, onError);
        });
    }, [_categorieIntervenantEXTPersonne, idCategorieIntervenantEXTPersonne]);

    // EFFECTS (ComponentDidUpdate)
    // Vérification des données du formulaire
    useEffect(() => {
        if (_isMounted.current)
            _onVerificationFormulaire();
    }, [_isMounted, _categorieIntervenantEXTPersonne]);

    // EFFECTS (ComponentDidMount)
    useEffect(() => {
        _isMounted.current = true;
    }, []);

    // RENDER
    return <EUIPanel
        headerText={idCategorieIntervenantEXTPersonne !== -1 ? "Modification de catégorie" : "Nouvelle catégorie"}
        isFormValid={_isFormValid}
        isOpen={isOpen}
        onDismiss={_onDismiss}
        onOpen={_onOpen}
        onSave={_onSave}
        type={PanelType.smallFixedFar}
    >

        <EUITextField
            label="Catégorie"
            maxLength={MaxLengths.categorieIntervenantEXTPersonne.categorieIntervenantEXTPersonne}
            onChange={_setFormIsNotValid}
            onDelayedChange={(event, newValue) => _setCategorieIntervenantEXTPersonne(prev => ({ ...prev, categorieIntervenantEXTPersonne: newValue }))}
            required
            value={_categorieIntervenantEXTPersonne.categorieIntervenantEXTPersonne}
        />

    </EUIPanel>

};

export default FicheCategorieIntervenantEXTPersonne;